import { gql, MutationHookOptions, useMutation } from '@apollo/client';

export function useMutationRemoveFromCart(
  options?: MutationHookOptions<RemoveFromCartData, RemoveFromCartVariables>,
) {
  const data = useMutation<RemoveFromCartData, RemoveFromCartVariables>(
    REMOVE_FROM_CART,
    {
      update(cache, _result, { variables }) {
        if (variables?.id == null) return;
        cache.evict({
          id: cache.identify({ __typename: 'CartItem', id: variables.id }),
        });
        cache.gc();
      },
      ...options,
    },
  );
  return data;
}

export const REMOVE_FROM_CART = gql`
  mutation removeFromCart($id: Int, $section: String) {
    removeFromCart(item: { id: $id }) {
      __typename
      items {
        id
        monitored(section: $section)
      }
    }
  }
`;

export type RemoveFromCartVariables = {
  id: number;
  section: string;
};

export type RemoveFromCartData = {
  removeFromCart: {
    __typename: string;
    items: { id: number; monitored: boolean }[];
  };
};
